<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-pie-chart">
    <div class="wy-va-optimization-pie-chart-title">
      <div class="title" :class="pieCharId">{{title}}</div>
      <!-- <i :wy-tooltip-content="titleToolTipContent" wy-tooltip-mode="hover" class="el-icon-info" :class="pieCharId"></i> -->
    </div>
    <div v-bind:id="pieCharId" class="pie-chart-content" :class="pieCharId" ref="pieCharId">
      <div v-if="piePercentageValue!='N/A'" class="display-value" 
        :class="{ 'full': formatStyle(piePercentageValue)>=5, 
                  'oneNumber': formatStyle(piePercentageValue)==1, 
                  'twoNumbers': formatStyle(piePercentageValue)==2, 
                  'threeNumbers': formatStyle(piePercentageValue)==3,
                  'fourNumbers': formatStyle(piePercentageValue)==4,
                  'green': markColor(piePercentageValue)=='green',
                  'yellow': markColor(piePercentageValue)=='yellow',
                  'red': markColor(piePercentageValue)=='red',
                  'no-color': markColor(piePercentageValue)=='no-color'}">
        {{piePercentageValue}}%
      </div>
      <div v-else class="display-value noNumber"  :class="{'no-color': markColor(piePercentageValue)=='no-color'}">
        N/A
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'wy-va-optimization-pie-chart',
  props: ['showLQIntentsMetric', 'title', 'parent', 'traceKey', 'traceList', 'titleToolTipContent', 'compareValues', 'targetKey'],

  data() {
    return {
      module: this,
      dataList: {},
      pieCharId: '',
      pieChartName: '',
      piePercentageValue: null,
      timeout: null
    }
  },

  watch: {
    traceKey(key) {
      if(key) {
        this.pieCharId = 'wy-va-optimization-pie-chart-chart-' + key;
      }
      setTimeout(()=>{
        this.buildChart();
      },100)
    },

    traceList() {
      this.buildChart();
    },
  },

  computed: {
    ...mapGetters(['companyConfig', 'companyProfileSettings']),
  },

  methods: {
    buildChart() {
      let pieLabels = this.traceList.map(el => el.label);
      let pieValues = this.traceList.map(el => el.value);
      let pieColors = this.traceList.map(el => el.color);
      this.piePercentageValue = pieValues[0];
      let chartData = [{
        type: 'pie',
        labels: pieLabels,
        values: pieValues,
        marker: {
          colors: pieColors,
          
        },
        textposition: "none",
        //automargin: true,
        hoverinfo: 'none',
        hole: 0.70,
        texttemplate: '   %{percent}   '
      }];

      let chartLayout = {
        // title: pieLabels[0],
        autosize: true,
        // width: '350',
        height: '135',
        
        paper_bgcolor: '#FCFEFF',
        showlegend: false,
        annotations: [
          {
            visible: false,
            text: pieValues[0] + '%',
            showarrow: false,
            font: {
              size: 20,
              color: '#214586',
            }
          }
        ],
        margin: { l: 20, r: 20, t: 20, b: 0 },
        legend: {
          orientation: 'h'
        }
      };
      if(chartData[0].labels.length >= 5){
        chartLayout.legend.font = {size: 8};
        chartLayout.margin = { l: 0, r: 0, t: 20, b: 0 };
        chartLayout.legend.y = -0.2;
        chartData[0].textfont = {size: 8};
      }
      let chartConfig = {responsive: true, displayModeBar: false, scrollZoom: false};
      // eslint-disable-next-line no-undef
      Plotly.newPlot(this.pieCharId, chartData, chartLayout, chartConfig);

      let plotPieChart = document.querySelector(this.pieCharId);
      if(plotPieChart) {
        plotPieChart.on('plotly_click', (data) => {
          if(data && data.points && data.points.length > 0){
            let label = data.points[0].label;
            this.parent.drillDownList.forEach(element => {
              if(element.drilldownId && element.label == label){
                this.parent.drillDownKeySelected = element.drilldownId;
              }
            });
          }
        });
      }
    },
    resizeWindowHandler() {
      if(this.$refs.pieCharId) {
        // eslint-disable-next-line no-undef
        Plotly.relayout(this.$refs.pieCharId, {})
        let dom = document.querySelector(".title.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood");
        if(dom && dom.offsetHeight) {
          if(dom.offsetHeight >= 25 && document.querySelector(".el-icon-info.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood")) {
            document.querySelector(".el-icon-info.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood").style.left = '119px'
          }
          else if(document.querySelector(".el-icon-info.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood")) {
            document.querySelector(".el-icon-info.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood").style.left = '154px'
          }
        }
      }
    },
    formatStyle(val) {
      if(val) {
        return val.toString().length;
      }
      else {
        return 1;
      }
    },
    markColor(val) {
      let targetKey = null
      if(this.pieChartName == 'overview') {
        targetKey = 'overviewTarget'
      }
      if(this.pieChartName == 'intentPerformance') {
        targetKey = 'nluIntentPerformanceTarget'
      }
      if(targetKey && this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings.optimization 
      && this.companyProfileSettings.targetSettings.settings.optimization[targetKey] && this.companyProfileSettings.targetSettings.settings.optimization[targetKey].length > 0) {
        let returnColor = 'no-color';
        this.companyProfileSettings.targetSettings.settings.optimization[targetKey].forEach(item => {
          if(item.key == this.targetKey) {
            let targetObject = item.target
            if(targetObject.reverse) {
              returnColor = (val > targetObject.value) ? 'red' : 'green';
            }
            else {
              returnColor = (val > targetObject.value) ? 'green' : 'red';
            }
          }
        })
        return returnColor;
      }
      else {
        return 'no-color';
      }
    }
  },

  mounted() {
    this.$root.registerTooltips(this.$el);
    this.pieCharId = 'wy-va-optimization-pie-chart-chart-' + this.traceKey;
    this.timeout = setTimeout(()=>{
      this.buildChart();
    },100)
    setTimeout(() => {
      const resize_ob = new ResizeObserver(() => {
        this.resizeWindowHandler()
      });
      if(document.querySelector(".wy-va-optimization")) {
        resize_ob.observe(document.querySelector(".wy-va-optimization"));
        this.pieChartName = 'overview'
      }
      if(document.querySelector(".wy-va-intent-performance")) {
        resize_ob.observe(document.querySelector(".wy-va-intent-performance"));
        this.pieChartName = 'intentPerformance'
      }
    }, 500);  
    
      document.querySelector(".optimization-details-table").style.position = 'unset'
      document.querySelector(".optimization-details-table").style.left = 'unset';           
  },

  beforeDestroy() {
    clearTimeout(this.timeout);
    this.$root.unregisterTooltips(this.$el);
  }
});
</script>

<style lang="scss">
  @keyframes changeSize {
    // 0%   { width: 100%; left: 0%; }
    // 50%  { width: 30%; left: 35%; }
    // 100% { width: 100%; left: 0%; }
  }
  .wy-va-optimization-pie-chart {
    .pie-chart-content {
      position: relative;
      height: 135px; // height will not change to 0 when resizing
      // animation-name: changeSize;
      // animation-duration: 3s;
      // animation-iteration-count: infinite;
      // animation-timing-function: ease-in-out;

      .display-value {
        font-weight: 700;
        color: var(--site-font-primary-color);
        z-index: 8;
        position: absolute;
        font-size: 15px;
        top: 50%;
        width: 18px;
        background-repeat: no-repeat;
        background-size: 35%;
        background-position-y: 3px;
        background-position-x: 0px;
        padding-left: 16px;
      }
      .display-value.full {
        left: calc(50% - 36px);
      }
      .display-value.noNumber{
        left: calc(50% - 30px);
      }
      .display-value.oneNumber{
        left: calc(50% - 19px);
      }
      .display-value.twoNumbers{
        left: calc(50% - 23px);
      }
      .display-value.threeNumbers{
        left: calc(50% - 28px);
      }
      .display-value.fourNumbers{
        left: calc(50% - 32px);
      }

      .display-value.oneNumber.no-color {
        left: calc(50% - 24px);
      }
      .display-value.twoNumbers.no-color {
        left: calc(50% - 29px);
      }
      .display-value.threeNumbers.no-color {
        left: calc(50% - 31px);
      }
      .display-value.fourNumbers.no-color {
        left: calc(50% - 36px);
      }
      .display-value.full.no-color {
        left: calc(50% - 40px);
      }
      .display-value.no-color {
        padding-left: 15px;
      }

      .green {
        background-repeat: no-repeat;
        background-image: url('../../assets/icons/icon-green-check.svg') !important;
      }
      .yellow {
        background-repeat: no-repeat;
        background-image: url('../../assets/icons/icon-yellow-warning.svg') !important;
      }
      .red {
        background-repeat: no-repeat;
        background-position-x: 1px !important;
        background-image: url('../../assets/icons/icon-red-warning.svg') !important;
      }
    }
    .wy-va-optimization-pie-chart-title {
      font-size: 12px;
      font-weight: 500;
      padding-bottom: 5px;
      padding-left: 0px;
      height: 38px;
      font-size: 13px;
      position: relative;

      > div {
        // max-width: 103px;
      }

      .el-icon-info {
        position: absolute;
        top: 18px;
        align-self: flex-end;
        color: #214586;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieUnderstanding {
        margin-left: 45px;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieContainment {
        margin-left: 44px;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieNegativeFeedbackScore {
        margin-left: 46px;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieEngagement {
        margin-left: 36px;
      }
      .title.wy-va-optimization-pie-chart-chart-pieNlu {
        margin-right: 10px;
      }
      .title.wy-va-optimization-pie-chart-chart-pieFalsePositives {
        margin-right: 10px;
      } 
      .title.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood {
        margin-right: 8px;
      }
      .title.wy-va-optimization-pie-chart-chart-pieLowQualityIntents {
        margin-right: 10px;
      }

      .el-icon-info.wy-va-optimization-pie-chart-chart-pieNlu {
        top: 2px;
        left: 89px;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieFalsePositives {
        top: 2px;
        left: 120px;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieMessagesNotUnderstood {
        top: 2px;
        left: 154px;
      }
      .el-icon-info.wy-va-optimization-pie-chart-chart-pieLowQualityIntents {
        top: 2px;
        left: 133px;
      }    
    }
  }
</style>